import { Invoice } from "../../../buy/services/invoice.model";
import { Action } from "../../../common/actions/core/action";
import ActionDispatcherService from "../../../common/actions/core/action-dispatcher.service";
import { ActionHandler } from "../../../common/actions/core/action-handler";
import NotificationService from "../../../common/services/notification/notification.service";
import UtilService from "../../../common/services/util.service";
import NoAuthService from "../../services/noauth.service";
import { NoAuthBillInfoChangeAction } from "../../components/actions/bill-info-change.action";
import { NoAuthBillInfoEditDialogAction } from "./bill-info-edit-dialog.action";
import GlobalSpinnerService from "../../../common/services/spinner/global-spinner.service";

/* @ngInject */
export default class NoAuthBillInfoEditController implements ActionHandler {
  private invoice: Invoice;
  private selectedCity: number;
  private dialogElement;

  private cities: any[];
  private towns: any[];

  constructor(
    private config,
    private $q,
    private $state,
    private $translate,
    protected $element,
    private $sanitize,
    private actionDispatcher: ActionDispatcherService,
    private noAuthService: NoAuthService,
    private globalSpinner: GlobalSpinnerService,
    private notificationService: NotificationService
  ) { }

  public $onInit() {
    if (angular.isUndefined(this.invoice)) {
      return;
    }

    this.$q.when(this.noAuthService.getCityList()).then(cities => {
      this.cities = cities;
      this.selectedCity = this.getCityIdByName(this.invoice.address.city);
      this.getTowns(false);
    });
  }

  public $postLink() {
    this.dialogElement = this.$element.find('#edit-invoice').remodal();
    this.actionDispatcher.register(this);
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof NoAuthBillInfoEditDialogAction) {
      this.invoice = action.invoice;
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.dialogElement.open();
  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
    this.$state.go('buy');
  }

  private getTowns(changed: boolean) {
    if (angular.isUndefined(this.invoice) || angular.isUndefined(this.invoice.address)) {
      this.towns = [];
    }
    this.$q
      .when(this.noAuthService.getCountyList(this.selectedCity))
      .then(towns => {
        this.towns = towns;
        if (changed || angular.isUndefined(this.invoice.address.county)) {
          this.invoice.address.county = this.towns[0].name;
        }
      });
  }

  public onCityChange() {
    this.getTowns(true);
  }

  public onNext() {
    this.globalSpinner.startIfNotActivated();
    this.dialogElement.close();
    this.invoice.address = {};
    this.invoice.address.country = this.config.defaultCountry;
    this.invoice.address.city = 'Türkiye';
    this.invoice.address.line1 = this.invoice.email;
    this.invoice.address.postalCode = '34000';
    this.invoice.identityNo = '11111111111';
    this.invoice.firstName = UtilService.decodeHtmlCharCodes(this.$sanitize(this.invoice.firstName));
    this.invoice.lastName = UtilService.decodeHtmlCharCodes(this.$sanitize(this.invoice.lastName));
    this.invoice.email = this.$sanitize(this.invoice.email);
    this.invoice.msisdn = this.$sanitize(this.invoice.msisdn);
    this.noAuthService.createUpdateInvoiceAddress(this.invoice).then(() => {
      this.actionDispatcher.dispatch(new NoAuthBillInfoChangeAction(this.invoice));
      this.globalSpinner.stop();
    });
  }

  private getCityIdByName(name: string): number {
    for (var item of this.cities) {
      if (item.name === name) {
        return item.id;
      }
    }
    return -1;
  }

  private getCityNameById(id: number) {
    for (var item of this.cities) {
      if (item.id === id) {
        return item.name;
      }
    }
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/app/no-auth/components/bill-info-edit/bill-info-edit.controller.ts